<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-bd animate-target" v-animate-in>
      <img class="cb-1" src="../../assets/images/p4-3/4-3-1.png" />
      <p>The ‘4 pillars of therapy’ to reduce CKD progression and CV risk<sup>1</sup> with finerenone recommended as a core treatment pillar<sup>4</sup></p>
    </div>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p4-3/4-3-2.png" />
    <div class="ctn-bd animate-target" v-animate-in>
      <img class="cb-2" src="../../assets/images/p4-3/4-3-3.png" />
      <p>To optimise risk reduction, the FOUR-PILLAR drug therapy should be combined with glycaemic control, blood pressure control, lipid control, smoking cessation, proper nutrition and regular exercise<sup>4</sup></p>
    </div>
    <GoNext class="animate-target" v-animate-in href="/section4/4-4">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s4-3",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"*In addition to glucose and blood pressure control.<br/><div class='brs'></div>"
      +"CKD, chronic kidney disease; CV, cardiovascular disease; GLP-1 RA, glucagon like peptide-1 receptor agonist; nsMRA, nonsteroidal mineralocorticoid receptor antagonist; RAS, Renin angiotensin system; SGLT-2i sodium glucose co transporter 2 inhibitor.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. KDIGO Diabetes Work Group. <i>Kidney Int</i> 2022;102:S1–S127;<br/>"
      +"2. American Diabetes Association. <i>Diabetes Care</i> 2023;46(Suppl1):S191–S202;<br/>"
      +"3. de Boer IH, <i>et al. Diabetes Care</i> 2022;45:3075–3090;<br/>"
      +"4. Blazek O & Bakris GL. <i>Am Heart J Plus</i> 2022;19:100187;",
      title:"Recent clinical guidelines for the management of CKD in people with T2D recommend a combination of drug therapies to optimally reduce risks<sup>1–4</sup>"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section4/s4.css";
.ctn-bd {
  margin-top:40px;
  display:flex;
  align-items: center;
}
.cb-1 {
  width: 70px;
  margin-right: 60px;
}
.cb-2 {
  width: 110px;
  margin-right: 20px;
}
.ctn-bd p {
  flex: 1;
  font-size: 20px;
  font-weight: bold;
}
.ctn-image {
  width: 100%;
  margin-top: 40px;
}
</style>
